<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Akun',

    metaInfo: { title: 'Akun' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'account',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'account',
      },
    },
  }
</script>
